import axios from 'axios'

import { servicingApi } from '../../config'

export const RECEIVED_ONBOARDINGS = 'RECEIVED_ONBOARDINGS'

export const receivedOnboardings = onboardings => ({
  type: RECEIVED_ONBOARDINGS,
  onboardings
})

export const fetchOnboardingSignUrl = (onboardingId, signatureId) => {
  return dispatch => {
    return axios.get(`${servicingApi}/onboarding/${onboardingId}/sign_url/${signatureId}`)
      .then(res => res.data)
  }
}
